module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/testimonials/laurent-crouzeix-8bc40e518a232aaf425953bfd5a49aab.png";